// start:ng42.barrel
export * from './nights-guests.component';
// end:ng42.barrel



// WEBPACK FOOTER //
// ./src/main/webapp/stay-mgmt/app/components/nights-guests/index.ts